import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const ANY_INVOICES = {
  YES: 'yes',
  NO: 'no',
} as const;

export const ANY_INVOICES_NAME = 'any_invoices';

interface Props {
  name?: string;
}

export const RadioGroupAnyInvoices: FC<Props> = ({
  name = ANY_INVOICES_NAME,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{i18n.t('Czy są faktury na naprawy?')}</FormLabel>
          <FormControl>
            <RadioGroup {...field} layout={'horizontal'}>
              <RadioItem
                data-testid={`${name}-radio-group-${ANY_INVOICES.YES}`}
                value={ANY_INVOICES.YES}
                label={i18n.t('Tak')}
              />
              <RadioItem
                data-testid={`${name}-radio-group-${ANY_INVOICES.NO}`}
                value={ANY_INVOICES.NO}
                label={i18n.t('Nie')}
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
